import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { strings } from '@constants'
import { Textarea, Button, TOAST_TYPE } from '@base'
import { toggleDrawer } from '@data/state/action/root'
import { FormBody, FormFooter, FormSection, SectionLabel } from './styles'
import { updateLead } from '@data/conn/put/leads'
import { showLoader, showToast } from '@data/state/action'

const AddNote = ({ leadData, update, note: existingNote }) => {
	const [notesList, setNotesList] = useState([])
	const dispatch = useDispatch()
	const [notes, setNotes] = useState(existingNote?.text || '')
	const user = useSelector((state) => state.getIn(['user', 'user']))
	const editor = user.getUserDetails()
	const isEdit = Boolean(existingNote)

	useEffect(() => {
		setNotesList(leadData?.notes?.reverse())
	}, [leadData])

	const handleSave = () => {
		if (!notes.trim()) return
		let _notes
		if (isEdit) {
			_notes = (notesList || []).map((n) => (n.date === existingNote.date ? { ...n, text: notes, editor, date: new Date().getTime() } : n))
		} else {
			const _note = { editor, text: notes, date: new Date().getTime() }
			_notes = notesList ? [...notesList, _note] : [_note]
		}
		dispatch(showLoader(true))
		updateLead({ ...leadData, notes: _notes })
			.then((response) => {
				setNotesList(response?.notes)
				setNotes('')
				dispatch(toggleDrawer(false))
			})
			.catch((err) => {
				dispatch(showToast(true, err?.response?.data?.message, { type: TOAST_TYPE.ERROR }))
			})
			.finally(() => {
				dispatch(showLoader(false))
				update()
			})
	}

	const handleCancel = () => {
		dispatch(toggleDrawer(false))
	}

	return (
		<>
			<FormBody>
				<FormSection>
					<SectionLabel>
						{strings('notes')} <span>*</span>
					</SectionLabel>
					<Textarea id='lead-notes' placeholder={strings(['add', 'notes'])} value={notes} onChange={setNotes} rows={6} />
				</FormSection>
			</FormBody>

			<FormFooter>
				<Button small type='primary' onClick={handleSave} disabled={!notes?.trim()}>
					{strings('save')}
				</Button>
				<Button small type='secondary' onClick={handleCancel}>
					{strings('cancel')}
				</Button>
			</FormFooter>
		</>
	)
}

export default AddNote
